import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const ZarazeniZakazky = {
	name: NAME,
	apiProvider,
	router,
};
